export default __webpack_public_path__ + "static/stream-thumbnail-6e44ae04c781b5753f2c0a18ca3063b4.png";